import { render, staticRenderFns } from "./DataFormat.vue?vue&type=template&id=d6b00b9e&scoped=true"
import script from "./DataFormat.vue?vue&type=script&lang=js"
export * from "./DataFormat.vue?vue&type=script&lang=js"
import style0 from "./DataFormat.vue?vue&type=style&index=0&id=d6b00b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b00b9e",
  null
  
)

export default component.exports